import React, { useEffect, useState } from 'react';
import Logo from './Logo';
import Navbar from './Navbar/Navbar';
import HeaderConfig from './HeaderConfig';
import './header.css';

const Header = ({
  navItems = [],
  logoSrc,
  contactHref = '/contact',
  contactIsExternal = false,
  homeTo = '/',
}) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const sticky = () => {
      setIsSticky(window.scrollY >= 250);
    };
    window.addEventListener('scroll', sticky);
    return () => window.removeEventListener('scroll', sticky);
  }, []);

  return (
    <header className={`header-area ${isSticky ? 'sticky' : 'not-sticky'}`}>
      <div className="container-header">
        <div className="row align-items-center">
          <div className="col-5 col-lg-2">
            <Logo logoSrc={logoSrc} homeTo={homeTo} />
          </div>
          <div className="col d-flex justify-content-end align-items-center">
            <Navbar navItems={navItems} />
            <HeaderConfig contactHref={contactHref} contactIsExternal={contactIsExternal} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
